declare global {
  interface Window {
    fbq?: any
  }
}

export type CheckoutPlan = 'esencial' | 'completo'

const PLAN_DATA: Record<CheckoutPlan, { name: string; value: number }> = {
  esencial: { name: 'Misión Influencia — Esencial', value: 19000 },
  completo: { name: 'Misión Influencia — Completo', value: 27000 },
}

export function trackInitiateCheckout(plan: CheckoutPlan) {
  if (typeof window === 'undefined' || !window.fbq) return
  const { name, value } = PLAN_DATA[plan]
  window.fbq('track', 'InitiateCheckout', {
    content_name: name,
    content_category: 'digital-product',
    content_ids: [plan],
    value,
    currency: 'ARS',
  })
}
